import { render, staticRenderFns } from "./mechanismList.vue?vue&type=template&id=16cfc36e"
import script from "./mechanismList.vue?vue&type=script&lang=js"
export * from "./mechanismList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports